import { useState, useEffect, useCallback } from 'react'
import Boton from '../../components/Boton'
import BuscadorArticulo from '../../components/BuscadorArticulo'
import { erpApi } from '../../api/erp'
import { mensajeError, useDepositos, st } from './_helpers'
import { colors } from '../../design/tokens'

/**
 * Stock — saldos por depósito del ERP. El depósito es un lugar
 * físico compartido con emp_0 (ADR-0010 §5): lo que hay en el estante.
 * El negativo se muestra tal cual: el sistema no lo esconde ni lo traba.
 */
export default function Emp900StockPage() {
  const depositos = useDepositos()
  const [deposito, setDeposito] = useState('')
  const [articulo, setArticulo] = useState(null)
  const [saldos, setSaldos] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState('')

  const cargar = useCallback(async () => {
    setLoading(true)
    try {
      const { data } = await erpApi.saldos({ deposito: deposito || undefined, sku: articulo?.codigo_alfa })
      setSaldos(data.saldos || []); setError('')
    } catch (e) { setError(mensajeError(e)) } finally { setLoading(false) }
  }, [deposito, articulo])

  useEffect(() => { cargar() }, [cargar])

  return (
    <div>
      <div style={st.header}><h2 style={st.title}>Stock</h2></div>
      <p style={st.sub}>Saldos del ERP (hasta 500 filas). Físico − comprometido = disponible.</p>

      <div style={st.filtros}>
        <select style={{ ...st.input, width: 200 }} value={deposito} onChange={e => setDeposito(e.target.value)}>
          <option value="">Todos los depósitos</option>
          {depositos.map(d => <option key={d.codigo} value={d.codigo}>{d.codigo} · {d.nombre}</option>)}
        </select>
        <div style={{ flex: 1, minWidth: 300 }}>
          {articulo
            ? <div style={st.chipTercero}><span style={st.chipCodigo}>{articulo.codigo_alfa}</span><span style={st.chipNombre}>{articulo.descripcion}</span><button type="button" style={st.chipQuitar} onClick={() => setArticulo(null)} aria-label="Quitar">×</button></div>
            : <BuscadorArticulo onSelect={setArticulo} />}
        </div>
        <Boton variante={deposito || articulo ? 'secondary' : 'ghost'} onClick={() => { setDeposito(''); setArticulo(null) }}>Limpiar</Boton>
      </div>

      {!loading && !error && <p style={st.info}>{saldos.length} artículo{saldos.length !== 1 ? 's' : ''} con saldo</p>}

      <div style={st.tableWrap}>
        <table style={st.table}>
          <thead><tr>{['SKU', 'Descripción', 'Depósito', 'Físico', 'Comprometido', 'Disponible'].map((h, i) => <th key={h} style={{ ...st.th, ...(i >= 3 ? { textAlign: 'right' } : {}) }}>{h}</th>)}</tr></thead>
          <tbody>
            {loading && saldos.length === 0 ? <tr><td colSpan={6} style={st.empty}>Cargando…</td></tr>
              : error ? <tr><td colSpan={6} style={st.empty}>{error}</td></tr>
                : saldos.length === 0 ? <tr><td colSpan={6} style={st.empty}>Sin saldos en el ERP para este filtro.</td></tr>
                  : saldos.map((s, i) => (
                    <tr key={i} style={st.tr}>
                      <td style={st.tdMono}>{s.sku}</td>
                      <td style={st.td}>{s.descripcion}</td>
                      <td style={st.tdMono}>{s.deposito}</td>
                      <td style={{ ...st.tdImporte, color: Number(s.fisico) < 0 ? colors.err : colors.text }}>{Number(s.fisico)}</td>
                      <td style={st.tdImporte}>{Number(s.comprometido)}</td>
                      <td style={{ ...st.tdImporte, color: Number(s.disponible) < 0 ? colors.err : colors.text }}>{Number(s.disponible)}</td>
                    </tr>
                  ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}
